import {Component, Input, OnInit} from '@angular/core';
import {StudentShoppingCartService} from "../../../services/student-shopping-cart.service";
import { CartProductV3 } from '../../../model/v3/shopping-cart';

@Component({
    selector: 'app-shopping-cart-product',
    templateUrl: './shopping-cart-product.component.html',
    styleUrls: ['./shopping-cart-product.component.scss'],
    standalone: false
})
export class ShoppingCartProductComponent implements OnInit {
  @Input() product: CartProductV3
  constructor(
    private shoppingCart: StudentShoppingCartService
  ) {}

  ngOnInit(): void {}

  getName() {
    return this.product.product.name || this.product.product.product?.name
  }

  getQuantity() {
    return this.product.quantity
  }

  getSum() {
    return `${(this.getQuantity() * (this.product.product.price?.value ?? 0)).toFixed(2)}
    ${this.shoppingCart.getCurrencySign()}`
  }

  increment() {
    this.shoppingCart.increment(this.product)
  }

  decrement() {
    this.shoppingCart.decrement(this.product)
  }

  delete() {
    this.shoppingCart.delete(this.product)
  }
}
